import { GroupResponse, PayloadGroup } from '@/models/content-group.model';
import { PermRole, RoleAppNav, UserRole } from '@/models/user-data.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessPermission } from 'src/app/models/access-permission';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayloadGroupsService {
  private BASE_URL = environment.payload_url + '/groups';

  groups = signal<PayloadGroup[]>([]);

  constructor(private http: HttpClient) {
    this.populateGroups();
   }

  getGroups(): Observable<GroupResponse> {
    return this.http.get<GroupResponse>(`${this.BASE_URL}`);
  }

  populateGroups() {
    this.getGroups().subscribe(groups => {
      this.groups.set(groups.items);
    });
  }
}
